var _defs, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDashesBottomRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 277.328,
    height: 162.828
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "dashes-bottom-right_svg__clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0-4h277.328v162.828H0z"
  })), /*#__PURE__*/React.createElement("style", null, ".dashes-bottom-right_svg__cls-3,.dashes-bottom-right_svg__cls-4{fill:none;stroke:#001847;stroke-linecap:round;stroke-width:2px}.dashes-bottom-right_svg__cls-4{stroke:#5f48e9}"))), /*#__PURE__*/React.createElement("g", {
    id: "dashes-bottom-right_svg__Scroll_Group_18",
    transform: "translate(0 4)",
    style: {
      isolation: "isolate"
    },
    clipPath: "url(#dashes-bottom-right_svg__clip-path)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "dashes-bottom-right_svg__Group_16276",
    transform: "translate(-1420.586 -921.086)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "dashes-bottom-right_svg__Line_165",
    d: "M0 0l63 63",
    className: "dashes-bottom-right_svg__cls-3",
    transform: "translate(1589.5 933.5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "dashes-bottom-right_svg__Line_166",
    d: "M0 0l63 63",
    className: "dashes-bottom-right_svg__cls-3",
    transform: "translate(1539.5 922.5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "dashes-bottom-right_svg__Line_169",
    d: "M0 0l82.5 83",
    className: "dashes-bottom-right_svg__cls-3",
    transform: "translate(1484 944.5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "dashes-bottom-right_svg__Line_171",
    d: "M0 0l40 40",
    className: "dashes-bottom-right_svg__cls-4",
    transform: "translate(1564 1064)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "dashes-bottom-right_svg__Line_167",
    d: "M0 0l63 63",
    className: "dashes-bottom-right_svg__cls-3",
    transform: "translate(1633.5 1016.5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "dashes-bottom-right_svg__Line_170",
    d: "M0 0l63 63",
    className: "dashes-bottom-right_svg__cls-3",
    transform: "translate(1598 1059.5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "dashes-bottom-right_svg__Line_168",
    d: "M0 0l114 114",
    className: "dashes-bottom-right_svg__cls-4",
    transform: "translate(1534.5 956.5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "dashes-bottom-right_svg__Line_172",
    d: "M0 0l40 40",
    className: "dashes-bottom-right_svg__cls-4",
    transform: "translate(1488 988)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "dashes-bottom-right_svg__Line_174",
    d: "M0 0l30 30",
    className: "dashes-bottom-right_svg__cls-4",
    transform: "translate(1448 1065)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "dashes-bottom-right_svg__Line_175",
    d: "M0 0l30 30",
    className: "dashes-bottom-right_svg__cls-3",
    transform: "translate(1457 1034)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "dashes-bottom-right_svg__Line_173",
    d: "M0 0l121 121",
    className: "dashes-bottom-right_svg__cls-3",
    transform: "translate(1422 961)"
  })))));
}

export default SvgDashesBottomRight;